var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"el",staticClass:"draggable",class:_vm.itemClass,attrs:{"draggable":"false"}},[_vm._t("default",null,{"onMouseDown":_vm.onDragStart})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }